module.exports = __webpack_public_path__ + "img/cont_icon02.12b7ad75.svg";